import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import api from '~/services/api';
import history from '~/services/history';

import {
  Container,
  Content,
  SearchBox,
  SearchIcon,
  Header,
  AddQuestionIcon,
  QuestionItem,
  TagItem,
} from './styles';

export default function AdminPanel() {
  const [questions, setQuestions] = useState([]);
  const [endOfPage, setEndOfPage] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  useEffect(() => {
    async function loadQuestions() {
      const response = await api.get('questions', {
        params: {
          search,
          page,
        },
      });

      if (response.data.questions.length > 0) {
        const moreQuestions = questions.concat(response.data.questions);
        setQuestions(moreQuestions);
      } else {
        setEndOfPage(true);
      }
    }

    loadQuestions();
  }, [page, search]); //eslint-disable-line

  useBottomScrollListener(() => (!endOfPage ? setPage(page + 1) : null), 500);

  function handleSearch(searchInput) {
    if (searchInput.charAt(searchInput.length - 1) !== ' ') {
      setPage(1);
      setEndOfPage(false);
      setSearch(searchInput);
      setQuestions([]);
    }
  }

  return (
    <Container>
      <Content>
        <SearchBox>
          <input
            placeholder="Buscar uma Pergunta"
            onChange={e => handleSearch(e.target.value)}
          />
          <SearchIcon size={20} color="#fff" />
        </SearchBox>

        <Header>
          <h1>Perguntas cadastradas</h1>

          <Link to="/panel/question/new">
            <AddQuestionIcon size={20} color="#fff" />
            Nova pergunta
          </Link>
        </Header>

        {questions.map(question => (
          <QuestionItem
            key={question.id}
            onClick={() => history.push(`/panel/question/${question.id}`)}
          >
            <strong>
              <h3>#{question.id}</h3>
              <h3>{question.question}</h3>
            </strong>

            <span>
              {question.categories.map(categorie => (
                <TagItem key={question.id + categorie}>{categorie}</TagItem>
              ))}
            </span>
          </QuestionItem>
        ))}
      </Content>
    </Container>
  );
}
